module.exports = __webpack_public_path__ + "img/buy.64d7c7db.png";